import axios from 'axios';
import serverMessage from '../server-message';

export default function get({ id }) {
  return new Promise((resolve, reject) => axios
    .get(`/account/system-admin/api/v1/bundle/${id}`)
    .then((response) => resolve(response.data))
    .catch((error) => reject(serverMessage(error))));
}
